import { useRef, useEffect } from 'preact/hooks'
import { useLocation } from 'wouter-preact'

/**
 * Die Navigation stand nur als Fußzeile unter der Themenliste. Von der
 * Kartenverwaltung zu den Statistiken hieß das: ans Ende scrollen, zurück zur
 * Themenliste, wieder ans Ende scrollen. Bei 360 Karten ist das ein weiter Weg.
 *
 * Sie steht jetzt oben und bleibt beim Scrollen stehen — oben und weglaufend
 * wäre derselbe Weg, nur rückwärts. Auf dem Telefon steht sie unten in der
 * Daumenzone (kopfzeile.css).
 *
 * Der Lernbildschirm bekommt sie nicht: er läuft nicht über `Seite` und bleibt
 * bei den fünf Dingen aus DESIGN.md.
 */
const BEREICHE = [
  { pfad: '/', name: 'Themen' },
  { pfad: '/karten', name: 'Karten' },
  { pfad: '/blaettern', name: 'Blättern' },
  { pfad: '/statistiken', name: 'Statistik' },
  { pfad: '/daten', name: 'Daten' },
  { pfad: '/einstellungen', name: 'Einstellungen' },
]

/** Die Editoren liegen unter /karten und färben dort mit. "/" nur sich selbst. */
function istAktiv(pfad, ort) {
  if (pfad === '/') return ort === '/'
  return ort === pfad || ort.startsWith(`${pfad}/`)
}

export function Kopfzeile() {
  const [ort] = useLocation()
  const liste = useRef(null)
  const aktivesFeld = useRef(null)

  // Auf dem Telefon passen nicht alle sechs Bereiche nebeneinander; die Zeile
  // scrollt dann. Steht man in einem Bereich weit rechts, wird er hergeholt —
  // über scrollLeft und nicht über scrollIntoView, das nähme die Seite mit.
  useEffect(() => {
    const spur = liste.current
    const feld = aktivesFeld.current
    if (!spur || !feld) return
    const links = feld.offsetLeft
    const rechts = links + feld.offsetWidth
    if (rechts > spur.scrollLeft + spur.clientWidth) {
      spur.scrollLeft = rechts - spur.clientWidth
    } else if (links < spur.scrollLeft) {
      spur.scrollLeft = links
    }
  }, [ort])

  return (
    <nav class="kopfzeile" aria-label="Bereiche">
      <ul class="kopfzeile__liste meta" ref={liste}>
        {BEREICHE.map((bereich) => {
          const aktiv = istAktiv(bereich.pfad, ort)
          return (
            <li key={bereich.pfad} ref={aktiv ? aktivesFeld : null}>
              <a
                class={`kopfzeile__link${aktiv ? ' kopfzeile__link--aktiv' : ''}`}
                href={bereich.pfad}
                aria-current={aktiv ? 'page' : undefined}
              >
                {bereich.name}
              </a>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
